import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
    h1: {
      color: "#0F202B",
      fontSize: "50px",
      fontWeight: "600",
    },
  },
  components: {
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
        disableRestoreFocus: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
        disableRestoreFocus: true,
      },
    },
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          disableScrollLock: true,
          disableRestoreFocus: true,
        },
      },
      styleOverrides: {
        select: {
          display: "block !important",
          whiteSpace: "nowrap !important",
          overflow: "hidden !important",
          textOverflow: "ellipsis !important",
        },
      },
    },
  },
});

export default theme;
